import * as React from 'react';

export default ({ notification, onDelete }) => {
    if (!notification) {
        return (
            <div className="notification-wrapper">
                <div className="notification-content">
                    <div className="notification-content empty">{i18next.t('notifications.select_one')}</div>
                </div>
            </div>
        );
    }

    return (
        <div className="notification-wrapper">
            <div className="notification-content">
                <div className="notification-banner">
                    <img alt="Banner" src="/images/wisemetering/negative-logo-horizontal.png"></img>
                </div>
                <div className="notification-header">
                    <h3 className="notification-title">{notification.get('title')}</h3>
                    <div onClick={() => onDelete(notification.id)}>
                        <span className="notification-delete-btn fas fa-trash">&nbsp;</span>
                    </div>
                </div>
                <div className="notification-date">{WiseMetering.utils.formatDate(notification.get('created_at'))}</div>
                <div className="notification-area" dangerouslySetInnerHTML={{ __html: notification.get('body') }}/>
                <footer className="notification-footer">
                    <p><b>WiseMetering</b></p>
                    <p>Rua Afonso Annes Penedo, 56</p>
                    <p>1950-014 Lisbon, Portugal</p>
                </footer>
            </div>
        </div>
    );
};
